import { render, staticRenderFns } from "./ReportsGenderGapPillar.vue?vue&type=template&id=2f4e3510&scoped=true&"
import script from "./ReportsGenderGapPillar.vue?vue&type=script&lang=js&"
export * from "./ReportsGenderGapPillar.vue?vue&type=script&lang=js&"
import style0 from "./ReportsGenderGapPillar.vue?vue&type=style&index=0&id=2f4e3510&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4e3510",
  null
  
)

export default component.exports